import { Guid } from '../../../application/store/model/guid';
import { SceneLinkGuid } from './SceneLink';
import { TourScenePanoramaDto } from '@ael/core-api';
import uuid from 'uuid';

export type SceneGuid = Guid & { __brand: 'sceneGuid' };

export type SceneProcessingState = 'success' | 'processing' | 'failed';

export type Scene = {
  guid: SceneGuid;
  name: string;
  thumbnailUrl: string | null;
  linkGuids: SceneLinkGuid[];
  sceneProcessingState: SceneProcessingState;
  renderSettings: TourScenePanoramaDto;
};

export const SceneHelper = {
  create: (
    name: string,
    thumbnailUrl: string | null,
    linkGuids: SceneLinkGuid[],
    processingState: SceneProcessingState,
    renderSettings: TourScenePanoramaDto
  ): Scene => ({
    guid: createSceneGuid(),
    name,
    thumbnailUrl,
    linkGuids,
    sceneProcessingState: processingState,
    renderSettings,
  }),
  addNewLink: (scene: Scene, linkGuid: SceneLinkGuid): Scene => ({
    ...scene,
    linkGuids: [...scene.linkGuids, linkGuid],
  }),
  removeLink: (scene: Scene, linkGuid: SceneLinkGuid): Scene => ({
    ...scene,
    linkGuids: scene.linkGuids.filter((g) => g !== linkGuid),
  }),
  getDefaultRenderSettings: () => defaultRenderSettings,
  changeUnderlyingPanorama: (
    scene: Scene,
    name: string,
    thumbnailUrl: string | null,
    processingState: SceneProcessingState,
    renderSettings: TourScenePanoramaDto
  ): Scene => ({
    ...scene,
    name,
    thumbnailUrl,
    sceneProcessingState: processingState,
    renderSettings,
  }),
};

function createSceneGuid(): SceneGuid {
  return uuid() as SceneGuid;
}

const defaultRenderSettings: TourScenePanoramaDto = {
  baseDir: '',
  urlSuffix: '',
  startingSceneIndex: 0,
  xmlDefinition:
    '<?xml version="1.0"?><krpano><scene><preview type="grid(cube,64,64,1024,0x232d33,0x0d1010,0xfdc23b);"/><view hlookat="0" vlookat="0" fovtype="HFOV" fisheye="0" fovmin="60" fov="130" fovmax="150"/></scene></krpano>',
};
